<template>
  <v-dialog v-model="show" max-width="1250px" scrollable>
    <v-card>
      <v-card-title class="py-2 rdg-naslov">
        <span class="rdg-ime">{{ naslov }}</span>
        <span class="rdg-meta ml-4">{{ podnaslov }}</span>
        <v-spacer></v-spacer>
        <v-checkbox
          v-model="sKontima"
          dense
          hide-details
          class="mt-0 pt-0 mr-4 kvacica"
          label="Konta u ispisu"
        ></v-checkbox>
        <!-- Samo na bilanci: zatvara li se aktiva s pasivom i, ako ne, zasto. -->
        <v-btn v-if="jeBilanca" small outlined
               :color="provjera && !provjera.tekuca.zatvara ? 'error' : 'primary'"
               class="mr-2" @click="prikaziProvjeru = !prikaziProvjeru">
          Provjeri
        </v-btn>
        <v-btn small outlined color="primary" class="mr-2" @click="ispisi">Printaj</v-btn>
        <v-btn small outlined class="mr-2" @click="uExcel">Excel</v-btn>
        <v-btn icon @click="show = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-divider></v-divider>

      <div v-if="prikaziProvjeru && provjera" class="provjera">
        <table class="provjera-tbl">
          <thead>
            <tr><th class="l"></th><th>{{ prethodnaGodina }}</th><th>{{ tekucaGodina }}</th></tr>
          </thead>
          <tbody>
            <tr><td class="l">Ukupno aktiva</td><td class="num">{{ iznos(provjera.prethodna.aktiva) }}</td><td class="num">{{ iznos(provjera.tekuca.aktiva) }}</td></tr>
            <tr><td class="l">Ukupno pasiva</td><td class="num">{{ iznos(provjera.prethodna.pasiva) }}</td><td class="num">{{ iznos(provjera.tekuca.pasiva) }}</td></tr>
            <tr class="razlika">
              <td class="l">Razlika</td>
              <td class="num" :class="provjera.prethodna.zatvara ? 'ok' : 'nije'">{{ iznos(provjera.prethodna.razlika) }}</td>
              <td class="num" :class="provjera.tekuca.zatvara ? 'ok' : 'nije'">{{ iznos(provjera.tekuca.razlika) }}</td>
            </tr>
          </tbody>
        </table>

        <!-- Popis knjizenja ima smisla samo za tekucu godinu: usporedna kolona
             je druga poslovna godina i otvara se zasebno. -->
        <div v-if="imaStoPokazati" class="mt-2">
          <v-btn x-small outlined color="primary" :loading="trazim" @click="pokaziKnjizenja">
            {{ knjizenja ? 'Sakrij knjiženja' : 'Prikaži knjiženja (' + tekucaGodina + ')' }}
          </v-btn>
        </div>

        <div v-if="knjizenja" class="knjizenja mt-2">
          <div v-if="!knjizenja.neuravnotezeni.length && !knjizenja.bezKonta.length" class="ok">
            Nema knjiženja s greškom - razlika je samo nezatvoreni rezultat.
          </div>

          <template v-if="knjizenja.neuravnotezeni.length">
            <div class="podnaslov">
              Temeljnice kojima duguje ≠ potražuje
              <span class="sitno">({{ knjizenja.neuravnotezeni.length }}, ukupno {{ iznos(knjizenja.zbroj.neuravnotezeni) }})</span>
            </div>
            <table class="knj-tbl">
              <thead>
                <tr><th class="l">Knjiga</th><th class="l">Broj</th><th class="l">Datum</th>
                  <th class="l">Partner / opis</th><th>Duguje</th><th>Potražuje</th><th>Razlika</th></tr>
              </thead>
              <tbody>
                <tr v-for="d in knjizenja.neuravnotezeni" :key="'n' + d.id">
                  <td class="l">{{ d.knjiga }}</td><td class="l">{{ d.broj }}</td>
                  <td class="l">{{ datum(d.datum) }}</td>
                  <td class="l">{{ d.partnerName || d.opis }}</td>
                  <td class="num">{{ iznos(d.duguje) }}</td>
                  <td class="num">{{ iznos(d.potrazuje) }}</td>
                  <td class="num nije">{{ iznos(d.razlika) }}</td>
                </tr>
              </tbody>
            </table>
          </template>

          <template v-if="knjizenja.bezKonta.length">
            <div class="podnaslov">
              Stavke bez konta
              <span class="sitno">({{ knjizenja.bezKonta.length }}, ukupno {{ iznos(knjizenja.zbroj.bezKonta) }})</span>
            </div>
            <table class="knj-tbl">
              <thead>
                <tr><th class="l">Knjiga</th><th class="l">Broj</th><th class="l">Datum</th>
                  <th class="l">Opis</th><th>Duguje</th><th>Potražuje</th><th>Iznos</th></tr>
              </thead>
              <tbody>
                <tr v-for="d in knjizenja.bezKonta" :key="'b' + d.id">
                  <td class="l">{{ d.knjiga }}</td><td class="l">{{ d.broj }}</td>
                  <td class="l">{{ datum(d.datum) }}</td>
                  <td class="l">{{ d.opis || d.partnerName }}</td>
                  <td class="num">{{ iznos(d.duguje) }}</td>
                  <td class="num">{{ iznos(d.potrazuje) }}</td>
                  <td class="num nije">{{ iznos(d.razlika) }}</td>
                </tr>
              </tbody>
            </table>
          </template>
        </div>

        <div v-for="g in ['tekuca', 'prethodna']" :key="g" class="ocjena">
          <template v-if="provjera[g].zatvara">
            <span class="ok">&#10003;</span>
            {{ g === 'tekuca' ? tekucaGodina : prethodnaGodina }}: bilanca se zatvara.
          </template>
          <template v-else>
            <span class="nije">&#10007;</span>
            {{ g === 'tekuca' ? tekucaGodina : prethodnaGodina }}: bilanca se <b>ne zatvara</b>,
            razlika {{ iznos(provjera[g].razlika) }} {{ currency }}.
            <template v-if="provjera[g].razlozi.length">Razlog: {{ razloziTekst(provjera[g]) }}.</template>
            <span v-if="imaIznos(provjera[g].neobjasnjeno)" class="nije">
              Neobjašnjeno ostaje {{ iznos(provjera[g].neobjasnjeno) }} - to treba pogledati ručno.
            </span>
          </template>
        </div>
      </div>
      <v-divider v-if="prikaziProvjeru && provjera"></v-divider>

      <v-card-text class="pa-0" style="max-height: 74vh;">
        <table class="rdg-tbl">
          <colgroup>
            <col style="width:56px">
            <col style="width:210px">
            <col>
            <col style="width:150px">
            <col style="width:150px">
          </colgroup>
          <thead>
            <tr>
              <th class="l">Ozn.</th>
              <th class="l">Konta iz RRiF-ovog plana</th>
              <th class="l">Naziv pozicije</th>
              <th>{{ prethodnaGodina }}</th>
              <th>{{ tekucaGodina }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(r, i) in redci" :key="i" :class="klasaRetka(r)">
              <td class="ozn">{{ r.col1 }}</td>
              <td class="konta">{{ r.col2 }}</td>
              <td class="naziv">{{ ocisti(r.col3) }}</td>
              <td class="num" :class="{nula: !r.col5}">{{ iznos(r.col5) }}</td>
              <td class="num" :class="{nula: !r.col6}">{{ iznos(r.col6) }}</td>
            </tr>
          </tbody>
        </table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// Prikaz financijskog izvjestaja na ekranu - racuna dobitka i gubitka i
// GFI-POD bilance. Oba izvjestaja daju retke istog oblika, pa dijele prikaz.
//
// Otvara se preko ref-a, iz MainLedgerCard1 nakon sto rdg2() ili doAll() slozi retke:
//   <MainLedgerStatement ref="izvjestaj" />
//   this.$refs.izvjestaj.open(this.fRDG, this.currency, 'Račun dobitka i gubitka')
//
// Tri su razine i razlikuju se po zastavicama:
//   header true             - rimski broj, zbroj cijelog odjeljka
//   header false, bold true - numerirana pozicija
//   oboje false             - podredak a) b) c), u col3 ima uvodni tab

import dayjs from 'dayjs'
import {printStatementPdf} from './mainLedgerPdf'
import {exportStatementXlsx} from './mainLedgerXlsx'
import {provjeriBilancu} from './bilancaProvjera'
import MainLedgerDnevnikService from '@/services/MainLedgerDnevnikService'

export default {
  name: 'MainLedgerStatement',
  data () {
    return {
      show: false,
      redci: [],
      head: {},
      currency: 'EUR',
      naslov: 'Račun dobitka i gubitka',
      // Kolona s kontima ostaje na ekranu radi provjere, ali u ispis i izvoz
      // ne ide osim ako se to izricito ne ukljuci - iz nje se vidi kako je RDG
      // sastavljen, a to korisnik servisa ne treba dobiti u ruke.
      sKontima: false,
      // Bruto bilanca obje godine; treba za objasnjenje zasto se ne zatvara.
      izvori: null,
      prikaziProvjeru: false,
      knjizenja: null,
      trazim: false
    }
  },
  computed: {
    provjera () {
      return provjeriBilancu({
        redci: this.redci,
        pItems: this.izvori ? this.izvori.pItems : [],
        pOldItems: this.izvori ? this.izvori.pOldItems : []
      })
    },
    jeBilanca () {
      return this.provjera.jeBilanca
    },
    // Nezatvorena godina nije greska u knjizenju, pa se za nju nema sto
    // pokazati; popis ima smisla samo za druga dva razloga.
    imaStoPokazati () {
      const t = this.provjera.tekuca
      return !!t && (Math.abs(t.neravnoteza) > 0.005 || Math.abs(t.bezKonta) > 0.005)
    },
    tekucaGodina () {
      return this.head.docToDate ? dayjs(this.head.docToDate).year() : 'Tekuća godina'
    },
    prethodnaGodina () {
      return this.head.docToDate ? dayjs(this.head.docToDate).year() - 1 : 'Prethodna godina'
    },
    podnaslov () {
      if (!this.head.docFromDate) { return this.currency }
      return dayjs(this.head.docFromDate).format('DD.MM.YYYY') + ' – ' +
        dayjs(this.head.docToDate).format('DD.MM.YYYY') + ' · ' + this.currency
    }
  },
  methods: {
    // Razlozi se spajaju u tekst ovdje, a ne u predlosku: v-for po rasponu
    // ostavlja razmake oko zareza i ispred tocke.
    datum (d) {
      return d ? dayjs(d).format('DD.MM.YYYY') : ''
    },
    async pokaziKnjizenja () {
      if (this.knjizenja) { this.knjizenja = null; return }
      this.trazim = true
      try {
        const {data} = await MainLedgerDnevnikService.neuravnotezeni({
          CompanyId: this.$store.state.companyid,
          BusinessYear: this.tekucaGodina
        })
        this.knjizenja = {
          neuravnotezeni: data.neuravnotezeni || [],
          bezKonta: data.bezKonta || [],
          zbroj: data.zbroj || {neuravnotezeni: 0, bezKonta: 0}
        }
      } catch (err) {
        this.knjizenja = {neuravnotezeni: [], bezKonta: [], zbroj: {neuravnotezeni: 0, bezKonta: 0},
          greska: err && err.message ? err.message : String(err)}
      }
      this.trazim = false
    },
    razloziTekst (g) {
      // Ispisuje se KOLIKO svaki razlog doprinosi razlici, a ne sirovi saldo -
      // tako se iznosi uz razloge zbroje u razliku i racun se moze pratiti.
      return g.razlozi.map(r => r.sto + ' ' + this.sPredznakom(r.iznos)).join(', ')
    },
    sPredznakom (v) {
      const n = Number(v) || 0
      return (n >= 0 ? '+' : '−') + this.iznos(Math.abs(n))
    },
    // "Math" nije dostupan u predlosku, pa provjera nule ide kroz metodu.
    imaIznos (v) {
      return Math.abs(Number(v) || 0) > 0.005
    },
    iznos (v) {
      if (!v || Math.abs(v) < 0.005) { return '–' }
      return Number(v).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    // col3 podredaka pocinje tabom; uvlaka se radi stilom, ne znakovima.
    ocisti (t) {
      return t ? String(t).replace(/^[\t\s]+/, '') : ''
    },
    klasaRetka (r) {
      if (r.header) { return 'odjeljak' }
      if (r.bold) { return 'pozicija' }
      return 'podredak'
    },
    open (fRDG, currency, naslov, izvori) {
      this.redci = fRDG && fRDG.items ? fRDG.items : []
      this.head = fRDG && fRDG.head ? fRDG.head : {}
      this.currency = currency || 'EUR'
      this.naslov = naslov || 'Račun dobitka i gubitka'
      this.izvori = izvori || null
      this.knjizenja = null
      // Provjera se ne otvara sama kad je sve u redu, ali kad bilanca ne stoji
      // otvara se odmah - inace bi se moralo znati da gumb treba pritisnuti.
      const p = provjeriBilancu({redci: this.redci, pItems: izvori ? izvori.pItems : [], pOldItems: izvori ? izvori.pOldItems : []})
      this.prikaziProvjeru = p.jeBilanca && !p.tekuca.zatvara
      this.show = true
    },
    zaIzvoz () {
      return {
        redci: this.redci,
        company: this.$store.state.companyActiv ? this.$store.state.companyActiv : {},
        fromDate: this.head.docFromDate,
        toDate: this.head.docToDate,
        valuta: this.currency,
        tekucaGodina: this.tekucaGodina,
        prethodnaGodina: this.prethodnaGodina,
        sKontima: this.sKontima,
        naslov: this.naslov
      }
    },
    ispisi () {
      printStatementPdf(this.zaIzvoz())
    },
    uExcel () {
      exportStatementXlsx(this.zaIzvoz())
    }
  }
}
</script>

<style scoped>
/* Provjera bilance. Namjerno iznad tablice i mirnih boja - nije upozorenje
   koje treba vikati, nego podatak uz izvjestaj. */
.provjera {
  padding: 10px 16px 12px;
  background: #f7f9fb;
  font-size: 13px;
  color: #191d1c;
}
.provjera-tbl { border-collapse: collapse; }
.provjera-tbl th, .provjera-tbl td { padding: 2px 10px; }
.provjera-tbl th { font-size: 11px; font-weight: 600; color: rgba(0,0,0,.55); text-align: right; }
.provjera-tbl th.l, .provjera-tbl td.l { text-align: left; }
.provjera-tbl td.num { text-align: right; font-variant-numeric: tabular-nums; }
.provjera-tbl tr.razlika td { border-top: 1px solid #c9d2da; font-weight: 700; }
.provjera .ocjena { margin-top: 6px; }
.provjera .ok { color: #2e7d32; font-weight: 700; }
.provjera .nije { color: #c62828; font-weight: 700; }
.provjera .knjizenja { border-top: 1px solid #dde3e8; padding-top: 8px; }
.provjera .podnaslov { font-weight: 700; margin: 6px 0 2px; }
.provjera .sitno { font-weight: 400; color: rgba(0,0,0,.55); }
.knj-tbl { border-collapse: collapse; width: 100%; font-size: 12px; }
.knj-tbl th { font-size: 11px; font-weight: 600; color: rgba(0,0,0,.55); text-align: right; padding: 2px 8px; }
.knj-tbl td { padding: 2px 8px; border-top: 1px solid #e7ecf0; }
.knj-tbl th.l, .knj-tbl td.l { text-align: left; }
.knj-tbl td.num { text-align: right; font-variant-numeric: tabular-nums; }

.rdg-naslov { font-size: 16px; }
.kvacica >>> label { font-size: 13px; }
.rdg-ime { font-weight: 700; }
.rdg-meta { font-size: 14px; color: rgba(0, 0, 0, .55); }

.rdg-tbl {
  border-collapse: collapse;
  width: 100%;
  font-size: 15px;
  color: #191d1c;
}

.rdg-tbl thead th {
  position: sticky;
  top: 0;
  background: #fff;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: .07em;
  text-transform: uppercase;
  color: #79827e;
  text-align: right;
  vertical-align: bottom;
  padding: 8px 10px;
  white-space: nowrap;
  border-bottom: 1px solid #c7cfcb;
  z-index: 2;
}
.rdg-tbl thead th.l { text-align: left; }

.rdg-tbl tbody td {
  padding: 3px 10px;
  border-bottom: 1px solid #e2e6e3;
  vertical-align: baseline;
}
.rdg-tbl td.num {
  text-align: right;
  font-variant-numeric: tabular-nums;
  font-size: 14px;
  white-space: nowrap;
}
.rdg-tbl td.nula { color: #b6bdb9; }
.rdg-tbl td.ozn { font-weight: 600; white-space: nowrap; }
.rdg-tbl td.konta { font-size: 13px; color: #79827e; }

/* tri razine, razlikuju se uvlakom i debljinom - bez podloga */
.rdg-tbl tr.odjeljak td {
  font-weight: 700;
  border-top: 2px solid #14534c;
  padding-top: 7px;
  padding-bottom: 5px;
}
.rdg-tbl tr.odjeljak td.ozn { color: #14534c; }
.rdg-tbl tr.odjeljak td.naziv { text-transform: uppercase; letter-spacing: .03em; font-size: 14px; }

.rdg-tbl tr.pozicija td { font-weight: 600; border-top: 1px solid #c7cfcb; }
.rdg-tbl tr.pozicija td.naziv { padding-left: 24px; }

.rdg-tbl tr.podredak td { color: #4a524f; }
.rdg-tbl tr.podredak td.naziv { padding-left: 46px; }
.rdg-tbl tr.podredak:hover td { background: #f1f5f3; }
</style>
